/* eslint-disable */

import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
} from "material-ui/Table";
import green from "material-ui/colors/green";
import { CircularProgress } from "material-ui/Progress";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import Tooltip from "material-ui/Tooltip";
import { withRouter } from "react-router";
import { lighten } from "material-ui/styles/colorManipulator";
import { translate } from "react-i18next";

import {
  getOrganizationAssetsConsuming,
  sortOrganizationAssetsConsuming,
  changePage,
  changeRowsPerPage
} from "../../actions";

const columnData = [
  { id: "name", numeric: false, disablePadding: false, label: "Name" }
];

class OrganizationAssetsConsumingListHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      t,
      i18n
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? "none" : "default"}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t("Sort")}
                  placement={column.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

OrganizationAssetsConsumingListHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};


const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85)
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark
        },
  spacer: {
    flex: "1 1 100%"
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: {
    flex: "0 0 auto"
  }
});
let OrganizationAssetsConsumingListToolbar = props => {
  const { numSelected, classes, loading, t, i18n } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            {t("Assets")}
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Typography>
        )}
      </div>
    </Toolbar>
  );
};

OrganizationAssetsConsumingListToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired
};

OrganizationAssetsConsumingListToolbar = withStyles(toolbarStyles)(OrganizationAssetsConsumingListToolbar);

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  buttonProgress: {
    color: green[500],
    position: "relative",
    bottom: -30,
    left: 100,
    marginTop: -12,
    marginLeft: -12
  }
});

class OrganizationAssetsConsumingList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: "asc",
      orderBy: "id",
      selected: [],
      data: [ ].sort((a, b) => (a.id < b.id ? -1 : 1)),
      page: 0,
      rowsPerPage: 5
    };
  }

  componentDidMount = () => {

    if (this.props.isAuthenticated) {
      const { match: { params } } = this.props;
      this.props.getOrganizationAssetsConsuming(params.organizationId);
    } else {
      this.props.history.push("/");
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.props.orderBy === property && this.props.order === "desc") {
      order = "asc";
    }

    const organizationAssetsConsuming =
      order === "desc"
        ? this.props.organizationAssetsConsuming.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
        : this.props.organizationAssetsConsuming.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

    this.props.sortOrganizationAssetsConsuming(organizationAssetsConsuming, order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.changePage(page);
  };

  handleClick = (event, id) => {
    this.props.history.push("/assets/cons/read/" + id);
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPage(event.target.value);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes } = this.props;

    const {
      organizationAssetsConsuming,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      loading,
      t,
      i18n
    } = this.props;

    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, organizationAssetsConsuming.length - page * rowsPerPage);

    return (
      <div className={classes.root}>
        <Paper className={classes.root}>
          <OrganizationAssetsConsumingListToolbar
            numSelected={selected.length}
            loading={loading}
            t={t}
            i18n={i18n}
          />
          <div>
            <Table className={classes.table} style={{ minWidth: 0 }}>
              <OrganizationAssetsConsumingListHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={organizationAssetsConsuming.length}
                t={t}
                i18n={i18n}
              />
              <TableBody>
                {organizationAssetsConsuming
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(n => {
                    const isSelected = this.isSelected(n._id);
                    const assetConsumingId = n.id

                    return (
                      <TableRow
                        hover
                        onClick={event => this.handleClick(event, assetConsumingId)}
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n._id}
                        selected={isSelected}
                      >
                        <TableCell
                          style={{
                            cursor: "pointer"
                          }}
                        >
                          {n.name
                            ? n.name
                            : t("Unknown")}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {
                    (organizationAssetsConsuming.length === 0) ? (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={false}
                        tabIndex={-1}
                        key="no-organization-consuming-assets"
                        selected={false}
                      >
                        <TableCell >
                          {t("There is no consuming assets yet")}
                        </TableCell>
                      </TableRow>
                    ) : (<div />)
                    }
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={organizationAssetsConsuming.length}
            labelDisplayedRows={({ from, to, count }) =>
              from + "-" + to + t(" of ") + count
            }
            labelRowsPerPage={t("RowsPerPage")}
            rowsPerPageOptions={[5, 10, 25, 100]}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    );
  }
}

OrganizationAssetsConsumingList.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = ({
  organizationsReducer,
  errorReducer,
  router,
  loginReducer
}) => {
  const {
    currentOrganization,
    organizationAssetsConsuming,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage
  } = organizationsReducer;
  const { location } = router;
  const { isAuthenticated, username, user } = loginReducer;
  return {
    currentOrganization,
    organizationAssetsConsuming,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    location,
    isAuthenticated,
    username,
    user
  };
};

const mapDispatchToProps = {
  getOrganizationAssetsConsuming,
  sortOrganizationAssetsConsuming,
  changePage,
  changeRowsPerPage
};

OrganizationAssetsConsumingList = withStyles(styles, { name: "OrganizationAssetsConsumingList" })(
  OrganizationAssetsConsumingList
);
OrganizationAssetsConsumingList = translate("translations")(OrganizationAssetsConsumingList);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrganizationAssetsConsumingList)
);



// WEBPACK FOOTER //
// ./src/components/Organization/OrganizationAssetsConsumingList.js